<template>
    <div>
        <b-modal
            :visible="value"
            :id="modal_id"
            size="lg"
            @cancel="cancel"
            @close="cancel"
            @ok="save"
            @hidden="hidden"
        >

            <template #modal-title>
                Edit Hot Text Target
            </template>

            <b-form-group
                label="Caption"
                label-for="caption"
            >
                <b-form-input v-model="editing_text" rows="2" max-rows="6" />
            </b-form-group>

            <b-form-checkbox
                v-model="editing_correct"
                :checked="editing_correct"
                switch
            >
                Hot Text Correct
            </b-form-checkbox>

            <template #modal-footer>
                <b-button variant="light" @click="cancel">
                    Cancel
                </b-button>
                <b-button variant="primary" @click="save">
                    Save Changes
                </b-button>
            </template>

        </b-modal>
    </div>
</template>

<style lang="scss" scoped>
    .url,
    .message {
        .copy-to-clipboard {
            visibility: hidden;
        }
        &:hover {
            .copy-to-clipboard {
                visibility: visible;
            }
        }
    }
</style>

<script>
export default {
    data: () => ({
        editing_text: '',
        editing_correct: null,
    }),
    props: [
        'value', 'selected_text', 'correct'
    ],
    components: {

    },
    computed: {
        modal_id () {
            let modal_id = 'edit-merlin-image-modal'
            return modal_id
        },
    },
    watch: {
        value: {
            handler (value) {
                if (value == true) {
                    if (this.image) {
                        if (this.image.width) {
                            this.image.width = this.image.width.replace('%', '')
                        }

                    }
                }
            }
        }
    },
    methods: {
        save () {
            this.$emit('save', this.editing_text, this.editing_correct)
        },
        cancel (event) {
            event.preventDefault()

            this.$emit('hide')
        },
        hidden () {
            this.$emit('hide')

            
        }
    },
    mounted () {
        this.editing_text = _.cloneDeep(this.selected_text);
        this.editing_correct = _.cloneDeep(this.correct);
    }
}
</script>
